import styled from 'styled-components';
import { media, layout } from 'src/components/base';
import { CardActionArea } from '@prisjakt/ui/card';
import { RowCard } from '@prisjakt/ui/card/variants';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { PriceLabel } from 'src/components/offer/price/price-label';
import { PRICE_LABEL_SIZE } from 'src/components/offer/price/offer-price/styles';

export const StyledRowCard = styled(RowCard)`
  background: ${props => props.theme.colors.base100};
  padding: ${layout.measurements.spacing050} 0;
  padding-left: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing050};

  ${media.mediumOnly`
    padding: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050} ${layout.measurements.spacing150};
  `}

  ${media.smallOnly`
    padding: ${layout.measurements.spacing050} ${layout.measurements.spacing075};
  `}
`;

export const StyledCardActionArea = styled(CardActionArea)`
  && {
    flex: 1;
    cursor: pointer;
    gap: ${layout.measurements.spacing050};

    ${media.smallOnly`
      gap: 0;
    `}
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex: 1;
  gap: ${layout.measurements.spacing050};
  align-items: center;
`;

export const StyledFirstWrapper = styled.div`
  text-align: initial;
`;

export const StyledSecondWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: end;
  gap: ${layout.measurements.spacing200};
  white-space: nowrap;
`;

export const StyledBodyText = styled(BodySmallText)`
  white-space: nowrap;
`;

export const StyledPriceLabel = styled(PriceLabel)`
  flex: 0 1 auto;
  font-size: ${PRICE_LABEL_SIZE};
`;

export const StyledCountText = styled.span`
  font-weight: 700;
`;

export const StyledGoToStoreButton = styled.div`
  display: flex;
  padding: 0 ${layout.measurements.spacing100} 0
    ${layout.measurements.spacing075};
  visibility: hidden;

  ${media.mediumOnly`
    padding: 0 ${layout.measurements.spacing050} 0 ${layout.measurements.spacing075};
  `}

  ${media.smallOnly`
    padding: 0;
  `}
`;

export const StyledButton = styled(Tooltip)`
  cursor: pointer;
  position: absolute;
  right: ${layout.measurements.spacing100};
  display: flex;
  align-self: center;

  ${media.mediumOnly`
    right: ${layout.measurements.spacing050};
  `}

  ${media.smallOnly`
    right: 0;
  `}
`;
